import { AppLayout } from 'layouts';
import { JoinedPrograms } from 'features/programs';
import { usePathToProgramDetail } from './hooks';

const PageJoinedPrograms = () => {
  // TODO resolve - JoinedPrograms are implemented differently from JoinedCommunities in how they handle route paths
  const getPathToEntityDetail = usePathToProgramDetail();

  return (
    <AppLayout>
      <JoinedPrograms getPathToProgramDetail={(id) => getPathToEntityDetail(id)} />
    </AppLayout>
  );
};

export default PageJoinedPrograms;
